import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import messages from "../../public/locales/en/admin.json";
import { useAppDispatch, useAppSelector } from "../store";
import {
  fetchContactSettings,
  saveContactSettings,
} from "../store/slices/contactSettingsSlice";

import type { ReactElement, FormEvent } from "react";

export default function ContactSettings(): ReactElement {
  const dispatch = useAppDispatch();
  const { settings, loading, saving, error } = useAppSelector(
    (state) => state.contactSettings,
  );
  const [email, setEmail] = useState("");
  const [saved, setSaved] = useState(false);
  const copy = messages.admin.settings;
  useEffect((): void => {
    void dispatch(fetchContactSettings());
  }, [dispatch]);
  useEffect((): void => {
    if (settings) setEmail(settings.supportEmail);
  }, [settings]);
  const submit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setSaved(false);
    const result = await dispatch(
      saveContactSettings({ supportEmail: email.trim() }),
    );
    if (saveContactSettings.fulfilled.match(result)) setSaved(true);
  };
  return (
    <Card>
      <CardHeader title={copy.contact.title} />
      <CardContent>
        <Typography variant="body2">{copy.contact.description}</Typography>
        {error && (
          <Alert severity="error">
            {settings ? copy.messages.saveFailed : copy.messages.loadFailed}
          </Alert>
        )}
        {saved && <Alert severity="success">{copy.messages.saveSuccess}</Alert>}
        {loading && <CircularProgress size={20} />}
        <form
          onSubmit={(event): void => {
            void submit(event);
          }}
        >
          <TextField
            fullWidth
            required
            type="email"
            label={copy.contact.supportEmail}
            value={email}
            disabled={loading || saving || settings === null}
            onChange={(event): void => {
              setEmail(event.target.value);
              setSaved(false);
            }}
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loading || saving || settings === null || !email.trim()}
          >
            {saving ? copy.actions.saving : copy.actions.save}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
